import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useLocation } from 'react-router-dom';
import styles from '../assets/styles/pages/Confirmation.module.scss';
import { FixedSpace } from '../components/FixedSpace';
import { Sidebar } from '../components/Sidebar';
import { Texts } from '../constants/Texts';
import { useCustomerContext } from '../context/Customer';
import * as routes from '../routing/routes';
import logo from '../assets/images/approval.png';
export const Confirmation = () => {
  const navigate = useNavigate();
  const customerContext = useCustomerContext();

  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname != customerContext.currentPosition) {
      customerContext.setCurrentPosition(routes.home);
      navigate(routes.home);
    }
  }, [pathname]);

  useEffect(() => {
    if (customerContext.currentPosition != routes.confirmation) navigate(customerContext.currentPosition!);
  }, [customerContext.currentPosition]);

  const restart = () => {
    customerContext.setCurrentPosition(routes.home);
    customerContext.restart();
  };

  return (
    <div className={styles.main}>
      <Sidebar firstHeader={Texts.CREATE_APPROVAL} secondHeader={Texts.PROTEXTION_CERTIFICATES} />
      <div className={styles.container}>
        <div>
          <div className={styles.header}>{Texts.PROTEXTION_CERTIFICATES_ENDED}</div>
          <FixedSpace height={'1rem'} />
          <div className={styles.img} style={{ backgroundImage: `url(${logo})` }} />
        </div>
        <div style={{ maxHeight: '3rem', minHeight: '1rem', flexGrow: '1' }} />
        <div>
          <div className={styles.message}>{Texts.EXPIRIATION_CERTIFICATION}</div>
          <FixedSpace height={'1rem'} />
          <div className={styles.header}>{Texts.THANK}</div>
          <FixedSpace height={'1rem'} />
          <div className={styles.restartBtn} onClick={restart}>
            <div>{Texts.ADDITIONAL_APPROVAL}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
